export default "__VITE_ASSET__d779c1ae__"